import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import {doubleToStringMonthly} from '../../objects/CommonUse/double_functions';
import {transportCostCalcAmt} from '../../objects/monthlyCalc/transportCostCalc';
import ConfigFile from '../../datasets/config_file';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import FriendDisplayModal from '../shared-components/friend_display_modal';
import { calcNbrFriendsMet } from './objects/calc_nbr_friends_met';
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';
import determineMoodPoints from '../../objects/CommonUse/determine_mood_points';
import createMoodPointArr from '../shared-components/objects/create_mood_point_arr';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import buildArrayForDisplay from '../../objects/CommonUse/build_array_for_display';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { loanBalanceCalcFunction } from '../../objects/AssetsExpenses/loan_balance_calc_function';
import { calcNbrMonthsBtwnDates } from '../../objects/CommonUse/nbr_months_btwn_dates_calc';
import buildMonthlyCarAmtsArr from './objects/build_monthly_car_amts_arr';
import replaceTextInString from '../../objects/CommonUse/replace_text_in_string';
import determineCreditScore from './objectsEndOfTurn/determine_credit_score';
import determineLoanIntRateChange from './objects/determine_loan_int_rate_chg';
import { createTableItem } from '../../objects/AssetsExpenses/create_table_item';
import determineIntRateCreditScoreLit from './objects/determine_int_rate_credit_score_lit';
import determineLoanMessage from './objectsCarChange/determine_loan_message';
import determineCashDownOptions from './objectsCarChange/determine_cash_down_options';
import calculateNewMonthlyPayAmt from './objectsCarChange/calculate_new_monthly_pay_amt';
import CarChangeModalInput from './car_change_modal_input';
import CarChangeModalTables from './car_change_modal_tables';
import calculateTradeInValue from './objectsCarChange/calculate_trade_in_value';


// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    creditReport: state.creditReport,
    timeWizardInfo: state.timeWizardInfo
    // add other Redux state slices here if needed
});


class CarChangeModal extends Component {
  constructor(props) {
    super(props);
    this.gameInfo = this.props.gameInfo();
    this.handleClick = this.handleDownPaymentChange.bind(this);
    this.handleClick = this.handleTradeInChange.bind(this);
    this.state={
         entryTab: [],
         loanType: "Car",
         headers: setHeadersForFetch(),
         allowConfirmBtn: false,
         carDataLoaded: false,
         loanProcessFee: ConfigFile.carItems.carLoanProcessFee,
         carIntRate: ConfigFile.carItems.carInterest,
         carLoanTerm: ConfigFile.carItems.carLoanTerm,
         openFriendModal: false,
         emptyArr: [],
         modalType: "TrainVideo",
         subProcess: "carChangeModal",
         environment: Config.dataURL.currentEnv,
    };
   // this.downPaymentAmt = 0;    
    this.newCarLoanAmtOriginal = 0;
    this.downPaymentChanged = true;
    this.appliedTradeInChanged = true;
    this.cashDownOptionsArr = [];
    this.carDataCurrent = null;
    this.currentCarId = null;
    this.monthlyAmtArr = [];
    this.loanIntRate = 0;
    this.intRateMsg = "";
    this.downPaymentAmt = 0;
    this.applyTradeIn = true;
    this.monthlyCompareAmtArr = [];
    this.newCar = {carCost: 0, carDesc: "", carId: "", carMPG: 0, carYearAdj: 0, carSize: 0,
      carAgeNbr: 0, autoInsuranceAmt: 0, noCar: false, busPassAmt: 0 }
    this.getCurrentCarData();
  }

  determineCarChangeAmts(){
      this.errorMsg = "";
      this.getNewCarData();
      this.getGameData();
      this.determineNewCarYear(); 
      this.modalTitle = "Cost Summary for " + this.newCarType;
      if (this.newCar.noCar === false){
          this.modalTitle += "-" + this.newCarYear;
      }
      let modalType = "";
      if (this.currentCarId === this.newCar.carId){
          if (+this.carDataCurrent.sizeNbr === 50){
              this.modalTitle = "Change is Not Valid";
              modalType = "SameCar";
              this.setState({modalType: "SameCar"});
          }else{
            if (this.nbrCarMonths <= 12)  {  
                this.modalTitle = "Change is Not Valid";
                modalType = "SameCar"
                this.setState({modalType: "SameCar"});
            }
          }
      }
      if (modalType !== "SameCar"){
          if (this.downPaymentChanged === true || this.appliedTradeInChanged === true){
              this.determineCurrentCarLoanAmt();
              if (this.currentCarNoCar === true){
                  this.tradeInAmt = 0;
              }else{
                    let carBrokenDown = false;
                    const checkBrokenDown = 
                        this.gameInfo.gameData.conditionsTable.find(elem => elem.condName === "car-broken-down");
                    if (checkBrokenDown){
                        carBrokenDown = true;
                        this.tradeInText = "Trade-in Value reduced due to car repairs required."
                    }
                    this.tradeInAmt = calculateTradeInValue(this.currentGameDate, this.currentCarYear, 
                        this.carDataCurrent.sizeNbr, this.carDataCurrent.cost, carBrokenDown);
              }
              this.checkIfNewLoanRequired();
              this.determineCarChangeMoodPoints();
              let currentLoanTradeInAmt = this.tradeInAmt;
              if (this.applyTradeIn === false){
                  currentLoanTradeInAmt = 0
              }
              let newLoanTradeInAmt = 0;
              if (currentLoanTradeInAmt > this.totalCurrentCarLoanAmt){
                   currentLoanTradeInAmt = this.totalCurrentCarLoanAmt;
                   newLoanTradeInAmt = +this.tradeInAmt - +currentLoanTradeInAmt
              }
              const monthlyDataObj = {monthlyIncome: this.monthlyIncome, carCost: this.newCar.carCost, 
                  totalCurrentCarLoanAmt: this.totalCurrentCarLoanAmt, tradeInAmt: this.tradeInAmt,
                  currentLoanTradeInAmt: currentLoanTradeInAmt, newLoanTradeInAmt: newLoanTradeInAmt,
                  downPaymentAmt: this.downPaymentAmt, loanAmt: this.newCarLoanAmt,
                  loanIntRate: this.loanIntRate
              }
              this.monthlyAmtArr = buildArrayForDisplay("CarChange", "CarMonthlyAmts", monthlyDataObj);
              const currentCar = {loanAmt: this.currentCarLoanAmt, autoInsAmt: this.currentAutoInsAmt,
                  busPassAmt: this.currentCarBusPassAmt  };
              const newCar = {loanAmt: this.monthlyCarLoanAmt, autoInsAmt: this.newCar.autoInsuranceAmt,
                  busPassAmt: this.newCar.busPassAmt };
              this.monthlyCompareAmtArr = buildMonthlyCarAmtsArr(currentCar, newCar);
              //  if the trade-in is less than the total loan amt, do not display in the cash
              //  section but it still reduces the amount of the loan.
              let tradeInAppliedToLoanAmt = this.tradeInAppliedToLoanAmt;
              if (+this.tradeInAppliedToCashAmt === 0 || this.applyTradeIn === true){
                  tradeInAppliedToLoanAmt = 0;
              }
              let noBikeAmt = 0;
              let noCarAmt = this.noCarAmt;
              if (this.buyBicycle === false){
                  noBikeAmt = this.noCarAmt;
                  noCarAmt = 0;
              }
              const cashAmtObj = {currentCash: this.gameInfo.gameData.currentCash, 
                  loanProcessAmt: this.loanProcessAmt, downPaymentAmt: this.downPaymentAmt, 
                  refundAmt: this.refundAmt, changeCashAmt: this.changeCashAmt,
                  noCarAmt: noCarAmt, noBikeAmt: noBikeAmt, appliedToLoan: tradeInAppliedToLoanAmt, 
                  tradeInProfit: this.tradeInAppliedToCashAmt}
              this.cashAmtArr = buildArrayForDisplay("CarChange", "CarCashAmts", cashAmtObj);
              this.setState({allowConfirmBtn: true});  
          }else{
              this.setState({allowConfirmBtn: false});
          }
          this.setState({modalType: "CalculationsComplete"});
      }
  }
  
  getNewCarData() {
    this.newCar.carCost = sessionStorage.getItem("carCost");
    this.newCar.carDesc = sessionStorage.getItem("carName");
    const carDescArr = this.newCar.carDesc.split(' - ');
    this.newCarType = carDescArr[0];
    this.newCar.carId = sessionStorage.getItem("carChoice");
    this.newCar.carMPG = sessionStorage.getItem("carMPG");
    this.newCar.carYearAdj = sessionStorage.getItem("carYearAdj");
    this.newCar.carSize = sessionStorage.getItem("carSize");
    this.newCar.carAgeNbr = sessionStorage.getItem("carAgeNbr");
    this.noCarAmt = 0;
    this.buyBicycle = false;
    if (+this.newCar.carSize === 50){
        this.newCar.noCar = true;
        this.newCar.busPassAmt = ConfigFile.gameStartItems.busPassAmt; this.noCarAmt = 0;
        const newShoeCost = ConfigFile.gameStartItems.walkingShoes;
        this.noCarAmt = +newShoeCost;
        this.buyBicycle = true;
        if (this.gameInfo.gamePurchases.purchaseTable){
              const purchaseTable = this.gameInfo.gamePurchases.purchaseTable;
              const purchaseObj = purchaseTable.find(elem => elem.itemName === "bicycle");
              if (purchaseObj){
                  //  do not add in bicycle cost because they already have a bicycle.
                   this.buyBicycle = false;
              }
        }
        if (this.buyBicycle === true){
            const bicycleCost = ConfigFile.gameStartItems.bicycleCost;
            this.noCarAmt += +bicycleCost;
        }
    }
  }
  
  getGameData() {
      const gameData = JSON.parse(JSON.stringify(this.gameInfo.gameData));
      this.loanTable = gameData.loanTable;
      this.expenseTable = gameData.expenseTable;
      this.currentCarYear = gameData.carInfo.carYear; 
      this.currentGameDate = gameData.currentGameDate; 
      var yearMonthVals = this.currentGameDate.split('-'); 
      this.currentGameYear = +yearMonthVals[0];
      yearMonthVals = gameData.startGameDate.split('-');
      this.startGameYear = +yearMonthVals[0];
      this.startGameDate = gameData.startGameDate;
  }

  determineNewCarYear(){
      const currentGameYear = this.currentGameDate.substr(0,4);
      this.newCarYear = (+currentGameYear - +this.newCar.carYearAdj).toString();
      sessionStorage.setItem("changeCarYear", this.newCarYear);
      let changeCarAgeNbr = (+currentGameYear - +this.newCarYear) * 12;
      sessionStorage.setItem("changeCarAgeNbr", changeCarAgeNbr);
      if (!this.gameInfo.gameData.carInfo.carGameDate){
          this.nbrCarMonths = 13;
      }else{
          const carDate = this.gameInfo.gameData.carInfo.carGameDate;
          this.nbrCarMonths = calcNbrMonthsBtwnDates(carDate, this.currentGameDate);
      }
  }

  checkIfNewLoanRequired(){
      // max downpayment is current loan balance + new car value minus the tradeInAmt
      // for the current car
      this.maxDownPayment = (+this.totalCurrentCarLoanAmt + +this.newCar.carCost -
          this.tradeInAmt).toFixed(2);
      if (+this.downPaymentAmt === +this.maxDownPayment ||
           this.newCar.noCar === true ){
           this.newLoanRequired = false;
      }else{
          this.newLoanRequired = true;
      }
      if (this.newLoanRequired === false){
          this.newCarLoanAmt = 0;
          this.loanProcessAmt = 0;
          this.monthlyCarLoanAmt = 0; 
          this.refundAmt = this.tradeInAmt;
          this.intRateMsg = "";
          this.calculateNewMonthlyPaymentAmts();
          if (this.totalCurrentCarLoanAmt > 0){
              this.determineCashDownOptionValues();
          }
          this.determineLoanMessage();
      }else{
          this.calculateNewTotalCarLoanAmt();
          this.calculateNewMonthlyPaymentAmts();
          this.determineCashDownOptionValues();
          this.determineLoanMessage();
      }
      this.appliedToLoanAmt = 0;
        
      this.tradeInProfit = 0;
      if (this.tradeInOption === false || this.applyTradeIn === true){
        //  trade-in amount will be applied to the current and new loan
          this.tradeInProfit = +this.tradeInAmt - +this.totalCurrentCarLoanAmt - +this.newCar.carCost;
          if (this.tradeInProfit > 0){
            this.tradeInAppliedToLoanAmt = this.totalCurrentCarLoanAmt + +this.newCar.carCost;
            this.tradeInAppliedToCashAmt = this.tradeInProfit;
          }else{
            this.tradeInProfit = 0;
            this.tradeInAppliedToLoanAmt = this.tradeInAmt;
            this.tradeInAppliedToCashAmt = 0;
          }
      }else{
          this.tradeInAppliedToCashAmt = this.tradeInAmt;
          this.tradeInAppliedToLoanAmt = 0;
      }
      this.calculateChangeToCashAmt();
      const estMonthlyIncome = +this.monthlyIncome + +this.currentCarLoanAmt - +this.monthlyCarLoanAmt;
      if (estMonthlyIncome < 0 && estMonthlyIncome < +this.monthlyIncome ){
          this.errorMsg = "Purchasing this car would cause your monthly income to be negative. " + 
          "You must choose another car or increase the down payment amount."
      }
   
      if (this.newLoanRequired === true && +this.creditScore < 600){
          let errorMsg = "Your new car loan has not been approved.  The lender has determined " +
            "that your credit score is too low.  Your current score is ||creditScore||. " + 
            "Your score must be greater than 600 to qualify for a car loan."
          const replaceObj = { string: this.creditScore };
          this.errorMsg = replaceTextInString(errorMsg, replaceObj, "creditScore", "string");
      }
  }

  determineLoanMessage(){
      
      this.loanMessage = determineLoanMessage(this.downPaymentAmt, this.totalCurrentCarLoanAmt,
          this.maxDownPayment, this.newLoanRequired, this.tradeInOption, this.applyTradeIn,
          this.addToCashAmt, this.tradeInAmt
      )
      if (this.newLoanRequired === true){
            this.confirmMessage = 
                "Click the 'Continue/Accept' button to accept the terms of this new loan."
            this.intRateMsg = determineIntRateCreditScoreLit(this.loanIntRate, "car", this.creditScore);
      }else{
            if (this.newCar.noCar === true){
                this.confirmMessage =
                  "Click 'Continue/Accept' to trade in your car and go car-free!";
            }else{
                this.confirmMessage = 
                  "Click the 'Continue/Accept' button to complete the purchase of this car.";
            }
            this.intRateMsg = "";
      }
  }

  determineCashDownOptionValues(){
      if (this.newCar.noCar === true){
          this.cashDownText = "You can enter a cash payment to reduce your loan...or..." +
          "pay it off completely.";
      }else{
          this.cashDownText = "You can choose to enter a cash amount. "  +
          "It will reduce your loan, or cover the full price if you want to pay in cash.";
      }
      this.cashDownOptionsArr = determineCashDownOptions(this.maxDownPayment, 
          this.gameInfo.gameData.currentCash, this.newCar.noCar, this.totalCurrentCarLoanAmt, 
          this.tradeInAmt, this.newCarLoanAmt, this.newCarLoanAmtOriginal);
  }

  calculateNewTotalCarLoanAmt(){
      this.loanProcessFee = 0;
      let tradeInAmt = this.tradeInAmt;
      if (this.applyTradeIn === false){
          tradeInAmt = 0
      }
      this.newCarLoanAmt = (this.newCar.carCost - tradeInAmt + 
              this.totalCurrentCarLoanAmt - +this.downPaymentAmt).toFixed(2); 
      if (+this.newCarLoanAmtOriginal === 0 || this.appliedTradeInChanged === true){
          this.newCarLoanAmtOriginal = JSON.parse(JSON.stringify(this.newCarLoanAmt));
      }
      this.loanProcessAmt = +this.newCar.carCost * +this.state.loanProcessFee;
  }

  calculateChangeToCashAmt(){
    
      this.refundAmt = 0;
      if (this.newCarLoanAmt <= 0){ 
          this.refundAmt = -1 * this.newCarLoanAmt;
          this.loanProcessAmt = 0;
          this.newCarLoanAmt = 0;
      }
      this.changeCashAmt = 
        -1 * (+this.loanProcessAmt + +this.downPaymentAmt - +this.tradeInAppliedToCashAmt +
            this.noCarAmt ); 
      this.newCashAmt = (+this.gameInfo.gameData.currentCash + this.changeCashAmt).toFixed(2);
      if (this.newCashAmt < 0){
         this.errorMsg = "Change to cash exceeds current cash amount. You must select a different car"
         if (this.downPaymentAmt > 0){
            this.errorMsg = this.errorMsg + " or reduce the downpayment amount."
         }else{
            this.errorMsg = this.errorMsg + '.';
         }
      }
      sessionStorage.setItem("changeCarNewCashAmt", this.newCashAmt);
  }

  determineCurrentCarLoanAmt() {
      this.currentLoanSw = false;
      this.totalCurrentCarLoanAmt = 0;
      this.currentCarLoanAmt = 0;
      for (let i=0; i<this.loanTable.length; i++) {
           // assumes only one active car loan for any given player.
           if (this.loanTable[i].loanType === "Car Loan" && 
              this.loanTable[i].loanNbrMonths !== "0") {
                 if (+this.loanTable[i].loanNbrMonths > 0) {
                    this.currentLoanSw = true;
                    this.currentCarLoanAmt = this.loanTable[i].loanAmt;
                    this.currentCarLoanIntRate = this.loanTable[i].loanIntRate;
                    this.currentCarLoanMonths = this.loanTable[i].loanNbrMonths;
                    this.totalCurrentCarLoanAmt = +loanBalanceCalcFunction(this.loanTable[i].loanTotAmt,
                      this.loanTable[i].loanIntRate, this.loanTable[i].loanAmt, this.loanTable[i].loanTerm,
                      this.loanTable[i].loanNbrMonths);
                }
           }
      }
  }

  calculateNewMonthlyPaymentAmts(){
      if (this.loanIntRate === 0 && this.newCar.noCar === false){
          this.loanIntRate = determineLoanIntRateChange(this.state.carIntRate, this.props.creditReport);
      }
      const monthlyPayObj = calculateNewMonthlyPayAmt(this.tradeInAmt, this.totalCurrentCarLoanAmt,
          this.newLoanRequired, this.newCarLoanAmt, this.state.carLoanTerm, this.applyTradeIn,
          this.downPaymentAmt, this.currentCarLoanAmt, this.currentCarLoanIntRate,
          this.gameInfo.gameData.expenseTable, this.newCar.noCar, this.newCar.carCost, this.newCar.carSize, 
          this.currentGameDate, this.loanIntRate );
      this.tradeInOption = monthlyPayObj.tradeInOption;
      this.tradeInOptionText = monthlyPayObj.tradeInOptionText;
      this.loanMonthsRemaining = monthlyPayObj.loanMonthsRemaining;
      this.monthlyCarLoanAmt = monthlyPayObj.monthlyCarLoanAmt;
      this.addToCashAmt = monthlyPayObj.addToCashAmt;
      this.currentAutoInsAmt = monthlyPayObj.currentAutoInsAmt;
      this.currentCarBusPassAmt = monthlyPayObj.currentCarBusPassAmt;
      this.newCar.autoInsuranceAmt = monthlyPayObj.newAutoInsuranceAmt;
      this.newAutoInsuranceObj = monthlyPayObj.newAutoInsuranceObj;
      this.monthlyAutoInsDiffAmt = monthlyPayObj.monthlyAutoInsDiffAmt;
      this.monthlyLoanDifferenceAmt = monthlyPayObj.monthlyLoanDifferenceAmt;

      let incomeObj = calcMonthlyIncome(this.gameInfo.gameData.assetTable,
            this.gameInfo.gameData.expenseTable, this.gameInfo.gameData.loanTable);
      this.monthlyIncome = incomeObj.income;
      if (this.monthlyIncome < (this.monthlyLoanDifferenceAmt + this.monthlyAutoInsDiffAmt)){
            this.warningMessage = "Warning: The monthly cost of this choice (together with other " +
              "monthly expenses) will exceed your monthly net income.";
      }
  }
    
  determineCarChangeMoodPoints(){
    let gameChoiceArr = [];
    this.startingMoodPoints = ConfigFile.gameChoice.carChangeMood;
    gameChoiceArr = createMoodPointArr("car");
    let moodObj = {};
    this.moodPointStartArr = determineMoodPoints(gameChoiceArr);
    moodObj = {choiceType: "baseAmt", label: "Starting Car Change Mood Points", number: this.startingMoodPoints,
      bold: true};
    this.moodPointStartArr.splice(0, 0, moodObj);
    this.totalMoodPoints = 0;
    for (let i=0; i<this.moodPointStartArr.length; i++){
         this.totalMoodPoints += +this.moodPointStartArr[i].number;
    }
    moodObj = {choiceType: "total", label: "Mood Point Change", number: this.totalMoodPoints,
      bold: true};
    this.moodPointStartArr.push(moodObj);
    if (this.totalMoodPoints > 0){
        this.moodPointText = "Your choice of a new car will increase your total mood points."
    }else{
        this.moodPointText = "You are happy to get a different car, but your choice of car " +
          "will not increase your mood points."
    }
    sessionStorage.setItem("carChangeMoodPoints", this.totalMoodPoints);
  }
   
   createNewTableObjects() {
      this.createNewLoanTableObject();
      this.createNewExpenseTableObject();
      this.props.onConfirmCarChange();
   }

   createNewLoanTableObject() {
      this.newLoanTable = this.loanTable;
      for (let i=0; i<this.newLoanTable.length; i++) {
          if (this.newLoanTable[i].loanType === "Car Loan" && 
              this.newLoanTable[i].loanNbrMonths !== "0") {
                if (this.loanMonthsRemaining > 0){
                    this.newLoanTable[i].loanNbrMonths = this.loanMonthsRemaining;
                }else{
                    this.newLoanTable[i].loanNbrMonths = 0;
                }          
          }
      }
      if (this.newCarLoanAmt > 0){
        const newCarLoanObj = createTableItem("car", this.newCar.carDesc, this.currentGameDate, 
          +this.newCarLoanAmt, this.currentGameDate, false, this.loanIntRate, this.props.creditReport);
        this.newLoanTable.push(newCarLoanObj);
      }
      sessionStorage.setItem("changeCarLoanDataObjects", JSON.stringify(this.newLoanTable));
   }

   createNewExpenseTableObject(){
      this.newExpenseTable = this.expenseTable;
      for (let i=0; i<this.newExpenseTable.length; i++){
          if ((this.newExpenseTable[i].expItem === "Transportation" ||
              this.newExpenseTable[i].expItem === "Automobile Insurance" ||
              this.newExpenseTable[i].expItem === "Bus Pass")  && 
              this.newExpenseTable[i].expNbrMonths !== "0") {
                this.newExpenseTable[i].expNbrMonths = 0;
          }
      }
      if (this.newCar.noCar === false){
        this.newTransportationExpenseObj = transportCostCalcAmt(this.newCar.carMPG, this.currentGameDate);
        this.newExpenseTable.push(this.newTransportationExpenseObj);
        this.newExpenseTable.push(this.newAutoInsuranceObj);
      }else{
        const newBusPassObj = createTableItem("busPass", "", this.currentGameDate, 
          this.newCar.busPassAmt, "", false);
        this.newExpenseTable.push(newBusPassObj);
      }
   
      sessionStorage.setItem("changeCarExpenseDataObjects", JSON.stringify(this.newExpenseTable));
  }
  
  render() { 

    let displayCalculations = false;
    if (this.state.modalType === "CalculationsComplete" && 
        (this.downPaymentChanged === true || this.appliedTradeInChanged === true )){
             this.nbrFriendsMet = calcNbrFriendsMet(this.gameInfo.gameData.friendList); 
           displayCalculations = true;
           this.downPaymentChanged = false;
           this.appliedTradeInChanged = false;
    }
    if (this.state.carDataLoaded === true){ 
        if (+this.carDataCurrent.sizeNbr === 50){
             this.currentCarNoCar = true;
        }
        if (this.state.modalType === "CalculationsComplete" || this.state.modalType === "SameCar"){
            //  car change amounts already calculated
        }else{
            this.determineCarChangeAmts();
        }
    }
   
    let cashDownOptions = false;
    if (this.cashDownOptionsArr.length > 0){
        cashDownOptions = true;
    }
  return <>
   
   <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg" scrollable="true"
        animation={false}>
        <Modal.Header  className="gameChoiceModalHdrFtrBackground" closeButton>
          <Modal.Title>{this.modalTitle}</Modal.Title> 
        </Modal.Header>
        <Modal.Body>
       
            {this.state.modalType === "TrainVideo"  ?
              <span>
                  <div className="text-white mt-4">xxxxxx</div>
                  <div className="text-white mt-4">xxxxxx</div>
                            <WaitTimeSpinner />
                  <div className="text-white mt-4">xxxxxx</div>
                  <div className="text-white mt-4">xxxxxx</div>
                  <div className="text-white mt-4">xxxxxx</div>
              </span>
          :
          <>
          {this.state.modalType === "SameCar" ? 
            <div>
              {this.newCar.noCar   ?
                <div>You do not currently own a car so you cannot choose the "No Car" option
                    again.  Please click on the 'close' button and then select
                    another option.
                </div>
              :
                <div>The car that you have selected is the same type and the same year
                  as your current car.  Please click on the 'close' button and then select
                  another option.
                </div>
              }
            </div>
        :
          <>
            <div className="mx-2">
                <b>Current Cash: &nbsp;</b>
                  {doubleToStringMonthly(this.gameInfo.gameData.currentCash)}
            </div>
            <CarChangeModalInput
                cashDownOptions = {cashDownOptions}
                tradeInOption = {this.tradeInOption}
                cashDownOptionsArr = {this.cashDownOptionsArr}
                cashDownText = {this.cashDownText}
                tradeInOptionText = {this.tradeInOptionText}
                downPaymentAmt = {this.downPaymentAmt}
                applyTradeIn = {this.applyTradeIn}
                handleDownPaymentChange = {(downPayAmt) => this.handleDownPaymentChange(downPayAmt)}
                handleTradeInChange = {(checked) => this.handleTradeInChange(checked)}
            />

             {this.currentLoanSw || this.newLoanRequired ?
                <div className="mx-2 mt-1">
                    {this.loanMessage}&nbsp;&nbsp;
                     <span className="font-weight-bold text-green">
                       {this.intRateMsg} 
                    </span>
                    <span>
                        &nbsp;&nbsp;{this.tradeInText}
                    </span>
                  
                    {this.state.allowConfirmBtn   ?
                          <span>
                              &nbsp;&nbsp;<b>{this.confirmMessage}</b>
                         </span>
                    :
                          null
                    }
                   
                </div>
            :
                null
            }
          

              <div className="text-danger my-2">
                    {this.warningMessage}
              </div>

            {displayCalculations   ?
                <CarChangeModalTables
                    monthlyAmtArr={this.monthlyAmtArr}
                    monthlyCompareAmtArr = {this.monthlyCompareAmtArr}
                    cashAmtArr = {this.cashAmtArr}
                    moodPointStartArr={this.moodPointStartArr}
                    moodPointText={this.moodPointText}
                    loanMonthsRemaining={this.loanMonthsRemaining}
                    currentCarLoanMonths={this.currentCarLoanMonths}
                />
            :
              null
            }
            
              {this.state.openFriendModal ?
                  <FriendDisplayModal  show={this.state.openFriendModal} 
                      title={this.newCar.carDesc}
                      gameProcess="GameViews"
                      askAFriendInfo={this.askAFriendInfo}
                      friendData={this.state.emptyArr}
                      onClose={() => this.closeFriendModal()} 
                      gameInfo = {() => this.props.gameInfo()}
                      />
              :
                null
              }
          </>
            }
            </>
          }
        </Modal.Body>
        <Modal.Footer  className="gameChoiceModalHdrFtrBackground">
            {this.nbrFriendsMet > 0 ?
                <Button variant="info" className="textLeft"  onClick={() => this.displayFriendModal()}>
                    Ask a Friend
              </Button>
            :
                null
            }
            
            <Button variant="secondary"   onClick={() => this.props.onClose()}>
                Cancel/Close
            </Button>
            {this.errorMsg === ""  && this.state.modalType !== "SameCar" ?
              <Button variant="primary"  onClick={() => this.createNewTableObjects()}>
                  Continue/Accept
              </Button>
            :
              <div className="text-danger">{this.errorMsg}</div>
            
            }
        </Modal.Footer>
      </Modal>
  
    </>
  }
  
  componentDidMount(){
    this._isMounted = true;
    const creditReport = determineCreditScore(this.gameInfo.creditCardInfo, 
          this.gameInfo.gameData.loanTable, this.gameInfo.gameData.currentGameDate,
          this.gameInfo.gameData.gameNbrMonths, this.props.timeWizardInfo );
    this.creditScore = creditReport.creditScore;
    this.props.setInfoRedux(creditReport, "creditReport");
  }
  
  componentWillUnmount(){
    this._isMounted = false;
  }
  
  displayFriendModal(){
    this.askAFriendInfo = {topic: "carChange", carAgeType: this.newCar.carAgeNbr,
      carSelectType: this.newCar.carSize}
    this.setState({openFriendModal: true});
  }

  closeFriendModal(){
    this.setState({openFriendModal: false});
  }
  
  handleDownPaymentChange(downPayment){
      this.downPaymentChanged = true;
      this.downPaymentAmt = downPayment;
      this.setState({modalType: ""});
  }
  
  handleTradeInChange(checked){
      this.downPaymentChanged = true;
      this.appliedTradeInChanged = true;
      this.downPaymentAmt = 0;
      this.applyTradeIn = checked;
      this.setState({modalType: ""});
  }
  
  getCurrentCarData() {
    this.currentCarId = this.gameInfo.gameData.carInfo.carID; 
    const funcName = "carInfo";
    const urlParm = "?carId=" + this.currentCarId;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {method:'GET', headers: this.state.headers})
        .then(response => {
          if (response.ok){
              response.json().then(data => {
              const output = JSON.parse(data);
              const statusCode = output.statusCode;
              if (statusCode === 200){
                this.carDataCurrent = output.body;
                if (this._isMounted === true){
                  this.setState({carDataLoaded: true});
                }
                }else{
                  const errorObj={function: funcName, subProcess: this.state.subProcess, 
                      status: statusCode, message: output.body.message};
                  this.props.processError(errorObj);
              }
          });
      }
      });
  }
 
}
export default connect(mapStateToProps, mapDispatchToProps)(CarChangeModal);